export default async function comparisonPriceTable() {
    if (!document.getElementById('spreadsheet-id') || document.getElementById('spreadsheet-id').value === null) {
        return;
    }

    const spreadsheetId = document.getElementById('spreadsheet-id').value;
    const backendUrl = `/storefirst/api/v1/comparison?id=${spreadsheetId}`;
    let comparisonData = {};

    // Update the last updated date in the span
    function updateLastUpdatedDate(date) {
        const lastUpdatedSpan = document.querySelector('.last-updated');
        if (lastUpdatedSpan) {
            lastUpdatedSpan.textContent = `Correct as of ${date}`;
        }
    }

    // Fetch comparison data from the backend
    async function fetchComparisonData() {
        const response = await fetch(backendUrl);
        const data = await response.json();
        return data;
    }

    // Generate a single row of the comparison table
    function generateTableRow(icon, label, column1Value, column2Value) {
        return `
            <div class="comparison-table__row">
              <div class="l-flex l-flex--middle comparison-table__left-col">
                <span class="o-body comparison-table__label">
                    ${icon !== null ? `<img src="${icon}" class="o-icon" />` : ''} 
                    ${label}
                </span>
              </div>
              <div class="comparison-table__right-col">
                <div class="l-flex">
                  <div class="l-flex l-flex--center-middle comparison-table__col comparison-price-table-first-row">
                    ${column1Value}
                  </div>
                  <div class="l-flex l-flex--center-middle comparison-table__col col-light">
                    ${column2Value}
                  </div>
                </div>
              </div>
            </div>`;
                }

    // Generate the dropdown options based on the available sqft sizes
    function generateDropdownOptions(currentSqftValue) {
        let options = '';

        [25, 50, 75, 100].forEach(sqft => {
            if (comparisonData.storefirst[`${sqft}sqft`] || comparisonData.competitor[`${sqft}sqft`]) {
                const isSelected = sqft.toString() === currentSqftValue ? 'selected' : '';
                options += `<option value="${sqft}" ${isSelected}>${sqft} sqft</option>`;
            }
        });

        return options;
    }

    // Get the value display based on the input value
    function getValueDisplay(value) {
        const trueValue = '<img src="/svg/ic_done-white.svg" class="o-icon" alt="Done Icon" />';
        const falseValue = '<img src="/svg/ic_close-white.svg" class="o-icon" alt="Cross Icon" />';

        if (value === "yes") {
            return trueValue;
        } else if (value === "no") {
            return falseValue;
        } else {
            return value;
        }
    }

    // Update the table with the appropriate rows and data
    function updateTable() {
        const sqftDropdown = document.getElementById('sqft-dropdown');
        const sqftValue = sqftDropdown.value;

        // Clear existing rows
        const rowsContainer = document.querySelector('.comparison-price-table .comparison-table__rows');
        rowsContainer.innerHTML = '';

        // Add the dropdown row
        const dropdownRow = `
    <div class="comparison-table__row">
      <div class="l-flex l-flex--middle comparison-table__left-col">
        <span class="o-body comparison-table__label"><img
            src="/svg/ic_warehouse.svg"
            class="o-icon"
            alt="Unit Size Icon" />
            Storage unit size (sqft)</span>
      </div>
      <div class="comparison-table__right-col">
        <div class="l-flex">
          <div class="l-flex l-flex--center-middle comparison-table__col">
            <select id="sqft-dropdown">
              ${generateDropdownOptions(sqftValue)}
            </select>
          </div>
          <div class="l-flex l-flex--center-middle comparison-table__col">
              ${sqftValue} sqft
          </div>
        </div>
      </div>
    </div>`;
        rowsContainer.insertAdjacentHTML('beforeend', dropdownRow);

        // Define the labels for the rows
        const labels = [
            {key: 'price_first_12_weeks', display: 'Price for the first 12 weeks', icon: 'https://groupfirst.s3.eu-west-2.amazonaws.com/storefirst/images/Icons/ic_notice-black.svg' },
            {key: 'includes_15000_contents_prot', display: 'Includes £15,000 contents protection', icon: 'https://groupfirst.s3.eu-west-2.amazonaws.com/storefirst/images/Icons/ic_security-black.svg'},
            {key: 'free_high_security_padlock', display: 'Free high security padlock', icon: 'https://groupfirst.s3.eu-west-2.amazonaws.com/storefirst/images/Icons/ic_padlock-black.svg'},
            {key: 'free_24_hour_storage_access', display: 'Free 24 hour storage access', icon: '/svg/ic_clock.svg'}
        ];

        let totalStoreFirstPrice = 0;
        let totalCompetitorPrice = 0;

        // Add rows for each label
        labels.forEach((labelObj) => {
            const storefirstSqftData = comparisonData['storefirst'][`${sqftValue}sqft`] || {};
            const competitorSqftData = comparisonData['competitor'][`${sqftValue}sqft`] || {};

            if (!storefirstSqftData[labelObj.key] && !competitorSqftData[labelObj.key]) {
                return;
            }

            const column1Value = getValueDisplay(storefirstSqftData[labelObj.key] || '-');
            const column2Value = getValueDisplay(competitorSqftData[labelObj.key] || '-');

            // Remove the '£' symbol and commas
            const storefirstValue = storefirstSqftData[labelObj.key] ? storefirstSqftData[labelObj.key].replace(/£|,/g, '') : '-';
            const competitorValue = competitorSqftData[labelObj.key] ? competitorSqftData[labelObj.key].replace(/£|,/g, '') : '-';

            // Check if the value is a number
            if (!isNaN(parseFloat(storefirstValue))) {
                totalStoreFirstPrice += parseFloat(storefirstValue);
            }

            if (!isNaN(parseFloat(competitorValue))) {
                totalCompetitorPrice += parseFloat(competitorValue);
            }

            const tableRow = generateTableRow(labelObj.icon, labelObj.display, column1Value, column2Value);
            rowsContainer.insertAdjacentHTML('beforeend', tableRow);
        });

        // Add total price row
        const totalSavings = (totalCompetitorPrice - totalStoreFirstPrice).toFixed(0);
        const weeklySavings = (totalSavings / 12).toFixed(0);
        const totalRow = generateTableRow(null,
            '<span class="total-price">Total Price</span>',
            `<span class="first-price">£${totalStoreFirstPrice.toFixed(0)}</span> <span class="save-amount">Save £${totalSavings}!</span> <span class="save-per-week">(£${weeklySavings} per week)</span><span class="last-updated">
    Correct as of 28 March 2023
  </span>`,
            `<span class="competitor-price">£${totalCompetitorPrice.toFixed(0)}</span>`);
        rowsContainer.insertAdjacentHTML('beforeend', totalRow);

        updateLastUpdatedDate(comparisonData.properties.last_updated);

        // Re-attach the event listener to the new dropdown element
        const newSqftDropdown = document.getElementById('sqft-dropdown');
        newSqftDropdown.removeEventListener('change', updateTable);
        newSqftDropdown.addEventListener('change', updateTable);
    }

    comparisonData = await fetchComparisonData();

    updateTable();

    // Update the last updated date
    if (comparisonData.properties && comparisonData.properties.last_updated) {
        updateLastUpdatedDate(comparisonData.properties.last_updated);
    }
}
